module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    staticClass: "noprint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v("打印")]), _vm._v(" "), _c('div', {
    staticClass: "noprint",
    on: {
      "click": _vm.routeBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printMe"
    }
  }, [(_vm.pageOneOpen) ? _c('div', {
    staticClass: "page page1"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）综合报表")])]), _vm._v(" "), _c('div', {
    staticClass: "table-head"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.startRender) ? _c('div', {
    staticClass: "content"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _vm._l((_vm.date_list), function(item) {
    return _c('td', {
      key: item,
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), _vm._l((_vm.statistics), function(row) {
    return _c('tr', {
      key: row,
      staticClass: "stat_res"
    }, _vm._l((row), function(col) {
      return _c('td', {
        key: col,
        domProps: {
          "innerHTML": _vm._s(col)
        }
      })
    }))
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.startRender) ? _c('div', {
    staticClass: "text-wrap"
  }, [_c('p', [_vm._v("CGM提示：共测定" + _vm._s(_vm.total_stat['num'][0]) + "个血糖值，平均值为" + _vm._s(_vm.total_stat['avg'][0]) + "mmol/L，\n            标准差为" + _vm._s(_vm.total_stat['sd'][0]) + "mmol/L，变异系数为" + _vm._s(_vm.total_stat['cv'][0]) + "，\n            最高值和最低值分别为" + _vm._s(_vm.total_stat['max'][0]) + "mmol/L和" + _vm._s(_vm.total_stat['min'][0]) + "mmol/L。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.target_low) + "-" + _vm._s(_vm.target_high) + "mmol/L (TIR)的时长和百分比为" + _vm._s(_vm.total_stat['bt_3d9_10'][0]) + "。")]), _vm._v(" "), _c('p', [_vm._v("≥7.8mmol/L、≥" + _vm._s(_vm.target_high) + "mmol/L和≥13.9mmol/L的时长和百分比分别为\n            " + _vm._s(_vm.total_stat['ge_7d8'][0]) + "，" + _vm._s(_vm.total_stat['ge_10'][0]) + "，" + _vm._s(_vm.total_stat['ge_13d9'][0]) + "。")]), _vm._v(" "), _c('p', [_vm._v("≤" + _vm._s(_vm.target_low) + "mmol/L、≤2.8mmol/L的时长和百分比分别为" + _vm._s(_vm.total_stat['le_3d9'][0]) + "，" + _vm._s(_vm.total_stat['le_2d8'][0]) + "。\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pageOneOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.pageTwoOpen) ? _c('div', {
    staticClass: "page agp-report",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）AGP图表")])]), _vm._v(" "), _c('div', {
    staticClass: "table-head"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('p', [_vm._v("葡萄糖统计")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_vm._v("CGM使用时间占比"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.cgmUse) + "%")]), _vm._v(" "), _c('td', [_vm._v("平均值±标准差"), _c('br'), _vm._v("MG±SD"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgSD) + " mmol/L")]), _vm._v(" "), _c('td', [_vm._v("葡萄糖管理指标"), _c('br'), _vm._v("（GMI）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.hba1c))]), _vm._v(" "), _c('td', [_vm._v("变异系数"), _c('br'), _vm._v("CV"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.cv))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("平均波动幅度"), _c('br'), _vm._v("MAGE"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgMage))]), _vm._v(" "), _c('td', [_vm._v("平均日间差异"), _c('br'), _vm._v("(MODD)"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.avgModd))]), _vm._v(" "), _c('td', [_vm._v("高血糖事件次数"), _c('br'), _vm._v("（每天）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.highSGNum))]), _vm._v(" "), _c('td', [_vm._v("低血糖事件次数"), _c('br'), _vm._v("（每天）"), _c('br'), _vm._v(_vm._s(_vm.AGPStat.lowSGNum))])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('div', {
    staticClass: "target",
    attrs: {
      "id": "dist_very_high_label"
    }
  }, [_c('p', [_vm._v("2级高血糖 : >" + _vm._s(_vm.target_veryhigh) + " mmol/L (" + _vm._s(_vm.target_over_13d9) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_high_label"
    }
  }, [_c('p', [_vm._v("1级高血糖 : " + _vm._s((_vm.target_high + 0.1).toFixed(1)) + "-" + _vm._s(_vm.target_veryhigh) + " mmol/L (" + _vm._s(_vm.target_ge_10) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_target_label"
    }
  }, [_c('p', [_vm._v("目标范围 : " + _vm._s(_vm.target_low) + "-" + _vm._s(_vm.target_high) + " mmol/L (" + _vm._s(_vm.target_bt_3d9_10) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_low_label"
    }
  }, [_c('p', [_vm._v("1级低血糖 :" + _vm._s(_vm.target_verylow) + "-" + _vm._s((_vm.target_low - 0.1).toFixed(1)) + " mmol/L (" + _vm._s(_vm.target_le_3d9) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "target",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "dist_very_low_label"
    }
  }, [_c('p', [_vm._v("2级低血糖 : <" + _vm._s(_vm.target_verylow) + " mmol/L (" + _vm._s(_vm.target_low_3) + ")")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [(_vm.dayNum > 2) ? _c('p', [_vm._v("AGP图谱")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agp-chart"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.pageTwoOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.chartIndexStart), function(pos, pageIndex) {
    return (_vm.pageThrOpen) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (pageIndex < _vm.totalPage),
        expression: "pageIndex < totalPage"
      }],
      key: pos,
      staticClass: "page",
      staticStyle: {
        "page-break-before": "always"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('p', [_vm._v(_vm._s(_vm.org_name))]), _vm._v(" "), _c('p', [_vm._v("持续葡萄糖监测（CGM）每日报告")])]), _vm._v(" "), _c('div', {
      staticClass: "table-head"
    }, [_c('table', [_c('tr', [_c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v("姓名：" + _vm._s(_vm.patient_info.Name) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v("性别：" + _vm._s(_vm.patient_info.Sex))]), _vm._v(" "), _c('td', [_vm._v("年龄：" + _vm._s(_vm.patient_info.Age))]), _vm._v(" "), _c('td', [_vm._v("手机号：" + _vm._s(_vm.patient_info.Mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("科室：" + _vm._s(_vm.patient_info.Dept))]), _vm._v(" "), _c('td', [_vm._v("住院号/门诊号：" + _vm._s(_vm.patient_info.AdmitNo) + " ")]), _vm._v(" "), _c('td', [_vm._v("床号:" + _vm._s(_vm.patient_info.bed))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("监测周期：" + _vm._s(_vm.time_range) + " ")]), _vm._v(" "), _c('td', [_vm._v("临床诊断：" + _vm._s(_vm.patient_info.Diag))]), _vm._v(" "), _c('td', [_vm._v("报告编号：" + _vm._s(_vm.reportNum))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "chart-wrap"
    }, [_vm._l((_vm.ds_title.slice(pos, pos + 7)), function(item, index) {
      return _c('div', {
        key: item.title
      }, [_c('p', [_vm._v(_vm._s(item.title) + "   平均值：" + _vm._s(item.avg) + " mmol/L TIR：" + _vm._s(item.TIR))]), _vm._v(" "), _c('div', {
        staticClass: "chart",
        attrs: {
          "id": 'chart' + (index + pos)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "event-list",
        attrs: {
          "id": 'event' + (index + pos)
        }
      }, [_c('p', {
        staticClass: "event-title"
      }, [_vm._v("事件：")]), _vm._v(" "), _vm._l((_vm.event['carb'][index]), function(data, carbIndex) {
        return _c('el-tooltip', {
          key: carbIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getCarb(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "carb img",
          attrs: {
            "src": require("../assets/Hcp-icon/legend/automode/icon_event_carb.png")
          }
        })])
      }), _vm._v(" "), _vm._l((_vm.event['exercise'][index]), function(data, exeriseIndex) {
        return _c('el-tooltip', {
          key: exeriseIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getExerciseTooltip(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "exe img",
          attrs: {
            "src": require("../assets/Hcp-icon/legend/automode/icon_event_exercise.png")
          }
        })])
      }), _vm._v(" "), _vm._l((_vm.event['ins'][index]), function(data, insIndex) {
        return _c('el-tooltip', {
          key: insIndex + Math.random(),
          attrs: {
            "effect": "dark",
            "content": _vm.getInstip(data),
            "placement": "top-start"
          }
        }, [_c('img', {
          staticClass: "ins img",
          attrs: {
            "src": require("../assets/Hcp-icon/legend/automode/icon_event_insulin.png")
          }
        })])
      })], 2)])
    }), _vm._v(" "), _c('div', [(false) ? _c('div', {
      staticClass: "xx_legend-wrap"
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "margin-left": "0",
        "float": "none"
      }
    }), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _vm._m(10, true), _vm._v(" "), _vm._m(11, true)]) : _vm._e(), _vm._v(" "), _vm._m(12, true)])], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.pageThrOpen) ? _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _vm._m(13)]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col2"
  }, [_c('div', {
    staticClass: "veryhigh",
    attrs: {
      "id": "dist_very_high"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "high",
    attrs: {
      "id": "dist_high"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "target",
    attrs: {
      "id": "dist_target"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "low",
    attrs: {
      "id": "dist_low"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "veryLow",
    attrs: {
      "id": "dist_very_low"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/transmitter.png")
    }
  }), _c('span', [_vm._v("新探头")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/warm up.png")
    }
  }), _c('span', [_vm._v("初始化")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v("血糖读数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/hypo.png")
    }
  }), _c('span', [_vm._v("低限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/target.png")
    }
  }), _c('span', [_vm._v("目标范围")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/calib.png")
    }
  }), _c('span', [_vm._v("校准")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/calibrate_1.png")
    }
  }), _c('span', [_vm._v("指间血糖")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v("餐食")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v("运动")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Hcp-icon/legend/automode/daily_legend.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("报告者：")]), _vm._v(" "), _c('td', [_vm._v("审核者：")]), _vm._v(" "), _c('td', {
    staticClass: "right"
  }, [_vm._v("报告日期：")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011893fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCGMReport.vue
// module id = 715
// module chunks = 1